import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PraticaCedente } from '../../../../core/api/models/praticaCedente.model';

import {
  LocalStorageService,
  ROUTE_ANIMATIONS_ELEMENTS
} from '../../../../core/core.module';

@Component({
  selector: 'mydyn-dettagli',
  templateUrl: './dettagli.component.html',
  styleUrls: ['./dettagli.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DettagliComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  pratica: PraticaCedente;

  constructor(
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    this.route.parent.params.subscribe((params) => {
      const pratiche: PraticaCedente[] = this.localStorageService.getItem(
        'PRATICHE'
      );
      for (const p of pratiche) {
        if (p.prtId === +params['id']) {
          this.pratica = p;
          break;
        }
      }
    });
  }
}
